<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ezPnqA/tc-custom/9781625854322.jpg?1702581818812" alt="This image is the cover for the book Capitals of the Confederacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Capitals of the Confederacy
      </h1>
      <p class="bookDescription body article font2">
        <b>“A handy, all-in-one reference on the Confederate capitals . . . Rich details and effective anecdotes . . . evok[e] a real sense of the people, places, and events” (<i>The Civil War Monitor</i>).</b><br/>  <br/> The Confederate States of America boasted five capital cities in four years. The center of the Confederate government moved from one Southern city to another, including Montgomery, Richmond, Danville, Greensboro, and Charlotte. From the heady early days of the new country to the dismal last hours of a transient government, each city played a role in the Confederate story. While some of these sites are commemorated with impressive monuments and museums, others offer scant evidence of their importance in Civil War history. Join award-winning historian Michael C. Hardy as he recounts the harrowing history of the capitals of the Confederacy.<br/>  <br/> Includes photos!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael C. Hardy
      </h2>
      
      <p class="authorDescription body article">Michael Hardy is a historian and author who has written an array of articles, blog posts and over eighteen books, including Civil War Charlotte, North Carolina in the Civil War and Watauga County, North Carolina in the Civil War. Hardy was awarded the 2010 Historian of the Year award by the North Carolina Society of Historians.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07aca3e8